var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddPartitionWall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "currentColor",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.909 12.774h-8.434V4.172c0-2.3-1.836-4.173-4.09-4.173h-.126c-2.296 0-4.133 1.873-4.133 4.173v8.6h-8.392c-2.254 0-4.09 1.874-4.133 4.173v.128c0 2.342 1.837 4.215 4.133 4.215h8.392v8.558c0 2.3 1.837 4.216 4.133 4.173h.125c2.255 0 4.091-1.873 4.091-4.173V21.29h8.434c2.254 0 4.091-1.873 4.091-4.173v-.17c0-2.299-1.837-4.173-4.091-4.173Zm-21.636 14.53v1.905c0 2.155.8 4.125 2.113 5.623H3.691C1.66 34.832 0 33.138 0 31.068s1.66-3.764 3.69-3.764h50.583ZM0 61.18v10.565c0 3.965 2.692 7.32 6.304 8.256h54.189c2.825-.733 5.087-2.944 5.939-5.77v-13.05c0-2.07-1.661-3.765-3.69-3.765H3.69C1.66 57.416 0 59.11 0 61.18Zm0-15.056c0-2.07 1.66-3.764 3.69-3.764h59.051c2.03 0 3.69 1.694 3.69 3.764s-1.66 3.764-3.69 3.764H3.691C1.66 49.888 0 48.194 0 46.124Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddPartitionWall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_partition_wall.3a641c1d05f9e350211d11877f201330.svg";